import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreCardWithLabel } from '../core-card-with-label/CoreCardWithLabel.ctrl';
import { LabelAndContentColumn } from '../label-and-content-column/LabelAndContentColumn.ctrl';
import type { LogicalDeviceBatteryInformationProps } from './logicalDeviceBatteryInformation.model';
import styles from './logicalDeviceBatteryInformation.module.scss';

export function LogicalDeviceBatteryInformation({ cycles, health }: LogicalDeviceBatteryInformationProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE]);
  return (
    <CoreCardWithLabel title={t('logicalDevice.batteryInformation.title')}>
      <div className={classNames(styles.container)}>
        <div className={classNames(styles.leftContainer)}>
          <LabelAndContentColumn label={t('logicalDevice.batteryInformation.cycles')} content={cycles} />
        </div>
        <div className={classNames(styles.rightContainer)}>
          <LabelAndContentColumn label={t('logicalDevice.batteryInformation.health')} content={health} />
        </div>
      </div>
    </CoreCardWithLabel>
  );
}
